import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5 py-5" }

import Drawer from '@/app/shared/components/drawer/Drawer.vue';
import Nav from '@/app/shared/components/Nav.vue';
import RightDrawer from '@/app/shared/components/drawer/RightDrawer.vue';
import Footer from '@/app/shared/components/Footer.vue';
import Breadcrumbs from '@/app/shared/components/Breadcrumbs.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTemplate',
  setup(__props) {

const snackbar = ref(true);

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(Drawer),
      _createVNode(Nav),
      _createVNode(RightDrawer),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Breadcrumbs)
          ]),
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(Footer)
    ]),
    _: 3
  }))
}
}

})